export default "__VITE_PUBLIC_ASSET__86cb63ac__"